import { useContext } from 'react';

import type { Ssm5Connection } from '../context/ssm5-connection.context';

import { Ssm5ConnectionContext } from '../context/ssm5-connection.context';

/**
 * Read the SSM5 connection provided by the nearest Ssm5ConnectionProvider.
 *
 * @throws {Error} when used outside an Ssm5ConnectionProvider
 * @returns the connection state with its transitions
 */
export function useSsm5Connection(): Ssm5Connection {
    const connection = useContext(Ssm5ConnectionContext);

    if (connection === undefined) {
        throw new Error('useSsm5Connection must be used within an Ssm5ConnectionProvider');
    }

    return connection;
}
